import {
  useIsAuthenticated,
  useMsal,
} from '@azure/msal-react';
import { useLazyVerifyTokenQuery } from '../services/auth';
import { useEffect } from 'react';
import dayjs from 'dayjs';

const EXPIRY_CHECK_TIME_IN_MLS = 5 * 60 * 1000;

export const tokenExpiringInMs = (
  token: string,
  timeInMs: number
) => {
  try {
    const expiry = JSON.parse(
      atob(token.split('.')[1])
    ).exp;
    return dayjs.unix(expiry).diff(dayjs()) <= timeInMs;
  } catch {
    return true;
  }
};

export const useRefreshTokenBeforeExpiry = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [verifyToken] = useLazyVerifyTokenQuery();

  const refreshToken = () => {
    instance
      .acquireTokenSilent({
        account: accounts[0],
        scopes: ['User.Read'],
      })
      .then((response) => {
        verifyToken({
          token: response?.accessToken,
        });
      })
      .catch((err) => {
        console.log('acquire token err:', err);
      });
  };

  const getRefreshTokenIfExpiringInTimeLimit = () => {
    const authToken = localStorage.getItem('authToken');
    const token = authToken && JSON.parse(authToken)?.token;
    if (
      !token ||
      tokenExpiringInMs(token, EXPIRY_CHECK_TIME_IN_MLS)
    ) {
      refreshToken();
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      // checking for first time
      getRefreshTokenIfExpiringInTimeLimit();
      const interval = setInterval(() => {
        // checking in intervals
        getRefreshTokenIfExpiringInTimeLimit();
      }, EXPIRY_CHECK_TIME_IN_MLS);
      return () => {
        clearInterval(interval);
      };
    }
  }, [isAuthenticated]);
};
